import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { AppProvider } from './providers';
import { securityManager } from './utils/security';
import { logger } from './utils/logger';
import './index.css';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import './styles/report-tables.css';
import { ErrorBoundary } from '@/components/Common/ErrorBoundary';

// Initialize CRM data when app starts
const AppInitializer: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  useEffect(() => {
    // Initialize security measures
    try {
      securityManager.initializeSecurity();
    } catch (error) {
      logger.error('Failed to initialize security', {
        error: error instanceof Error ? error.message : error
      });
    }
  }, []);

  return <>{children}</>;
};

function App() {
  return (
    <AppInitializer>
      <BrowserRouter basename={import.meta.env.VITE_APP_BASE_URL}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <AppProvider />
          </ErrorBoundary>
        </QueryClientProvider>
      </BrowserRouter>
    </AppInitializer>
  );
}

export default App;
